// extracted by mini-css-extract-plugin
module.exports = {"button":"_3Fcs3GqLHffzM5mpoCbrjQ","icon":"_3N4c5-qLsTcF0p7nXrWY9L"};